import {
  Box,
  Button,
  IconButton,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import Stamp from "components/stamp/stamp";
import Gauge from "components/stamp/gauge";
import { rem } from "assets/js/common";
import moment from "moment";
import { Cookies } from "react-cookie";
import { loadAlert, loadFavAlert } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

export default function stampWrap(props) {
  const dispatch = useDispatch();
  const { alertOpen, favAlertOpen } = useSelector((state) => state.top);
  const detailData = props.event ? props.event : props.detailData;
  const isDisabled = props.isDisabled ? props.isDisabled : false;

  const bgYn = props.bgYn;
  const event = props.event;

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp == "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const useStyles = makeStyles((theme) => ({
    stampDetail: {
      "& .type-gauge": {
        // padding: "45px 40px",
        "& .gauge-bgwrap": {
          // padding: `${rem(23)} ${rem(30)} ${rem(30)} ${rem(26)}`,
          padding: rem(30),
          borderRadius: rem(10),
          backgroundColor: theme.palette.common.white,
        },
        "&.detail-gauge": {
          "& .MuiLinearProgress-root": {
            margin: `${rem(-5)} 0 ${rem(15)}`,
          },
        },
      },
      "& .cnt-info": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& .cnt": {
          fontWeight: 700,
          "& b": {
            color: theme.palette.primary.main,
            fontSize: rem(18),
            fontWeight: 800,
          },
        },
        "& .cnt-detail": {
          fontSize: rem(14),
          color: "#8E8E8E",
        },
      },
      "& .bottom-wrap": {
        display: "flex",
        flexDirection: "column",
        "& .MuiButton-root": {
          marginTop: `${rem(40)}`,
          "& + .MuiButton-root": {
            marginTop: `${rem(22)}`,
          },
        },
        "& .btnLine": {
          lineHeight: rem(54),
        },
        "& .detail-btn": {
          fontSize: rem(14),
          marginLeft: 0,
          marginRight: 0,
          textDecoration: "underline",
          textUnderlinePosition: "under",
          fontWeight: "400",
        },
      },
      "& .reward": {
        padding: `${rem(35)} ${rem(25)} ${rem(45)} `,
        "& .reward-items": {
          justifyContent: "left",
          "& .MuiGrid-item": {
            display: "flex",
            //flex: 1,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            margin: "5px",
            position: "relative",
            width: "calc(50% - 10px)",
            // minWidth: rem(153),
            height: rem(130),
            "&:nth-child(2n)": {
              marginLeft: "4px",
            },
            "& .tit": {
              position: "relative",
              width: "100%",
              padding: `${rem(20)} 0 ${rem(16)}`,
              fontSize: rem(14),
              "&:before": {
                display: "block",
                content: "''",
                width: rem(6),
                height: rem(12),
                borderWidth: "1px 1px 1px 0",
                borderStyle: "solid",
                borderRadius: `${rem(0)} ${rem(6)} ${rem(6)} ${rem(0)}`,
                position: "absolute",
                left: rem(-1),
                bottom: rem(-6),
                background: "#f6f6f6",
              },
              "&:after": {
                display: "block",
                content: "''",
                width: rem(6),
                height: rem(12),
                borderWidth: "1px 0 1px 1px",
                borderStyle: "solid",
                borderRadius: `${rem(6)} ${rem(0)} ${rem(0)} ${rem(6)}`,
                position: "absolute",
                right: rem(-1),
                bottom: rem(-6),
                background: "#f6f6f6",
              },
              "& .amount": {
                fontSize: rem(22),
                fontWeight: 700,
                lineHeight: rem(24),
                marginTop: rem(4),
              },
              "& b": {
                fontWeight: "400",
              },
            },
            "& .detail": {
              padding: `${rem(12)} 0`,
              fontSize: rem(14),
              color: "#8E8E8E",
              "& span": {
                color: theme.palette.primary.main,
              },
            },
            "&.complete": {
              "& .tit, & .detail": {
                color: theme.palette.grey[100],
              },
            },
            "&.off": {
              "& .tit, & .detail": {
                color: theme.palette.text.disabled,
              },
              "&:after": {
                backgroundImage:
                  "linear-gradient(to right, #bebebe 40%, #ffffff00 20%)",
              },
            },
            "&:after": {
              display: "block",
              content: "''",
              width: "85%",
              height: "1px",
              backgroundImage:
                "linear-gradient(to right, #eee 40%, #ffffff00 20%)",
              backgroundPosition: "left",
              backgroundSize: "7px 1px",
              backgroundRepeat: "repeat-x",
              position: "absolute",
              top: "83px",
              left: "50%",
              marginLeft: "-42%",
            },
          },
          "& .on": {
            backgroundColor: "#fff",
            border: "1px solid #eee",
            borderRadius: rem(10),
            // backgroundImage: `url(${
            //   process.env.PUBLIC_URL
            // }/images/icon/reward-on.svg)`,
            // backgroundSize: "100% 130px",
            // backgroundRepeat: "no-repeat",
            "& .tit": {
              "&:before, &:after": {
                borderColor: "#eee",
              },
            },
          },
          "& .off": {
            backgroundColor: "#eee",
            border: "1px solid #dfdfdf",
            borderRadius: rem(10),
            // backgroundImage: `url(${
            //   process.env.PUBLIC_URL
            // }/images/icon/reward-off.svg)`,
            // backgroundSize: "100% 130px",
            // backgroundRepeat: "no-repeat",
            "& .tit": {
              "&:before, &:after": {
                borderColor: "#dfdfdf",
              },
            },
          },
          "& .complete": {
            // position: "absolute",
            // backgroundColor: "#ffffff8a",

            "& img": {
              position: "absolute",
              mixBlendMode: "multiply",
              zIndex: "1",
            },
          },
        },
        "& .reward-one": {
          justifyContent: "center",
          "& .MuiGrid-item": {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            margin: "5px",
            position: "relative",
            width: "100%",
            "& .tit": {
              position: "relative",
              width: "100%",
              padding: `${rem(20)} 0 ${rem(16)}`,
              fontSize: rem(14),
              "&:before": {
                display: "block",
                content: "''",
                width: rem(6),
                height: rem(12),
                borderWidth: "1px 1px 1px 0",
                borderStyle: "solid",
                borderRadius: `${rem(0)} ${rem(6)} ${rem(6)} ${rem(0)}`,
                position: "absolute",
                left: rem(-1),
                bottom: rem(-6),
                background: "#f6f6f6",
              },
              "&:after": {
                display: "block",
                content: "''",
                width: rem(6),
                height: rem(12),
                borderWidth: "1px 0 1px 1px",
                borderStyle: "solid",
                borderRadius: `${rem(6)} ${rem(0)} ${rem(0)} ${rem(6)}`,
                position: "absolute",
                right: rem(-1),
                bottom: rem(-6),
                background: "#f6f6f6",
              },
              "& .amount": {
                fontSize: rem(22),
                fontWeight: 700,
                lineHeight: rem(24),
                marginTop: rem(4),
              },
              "& b": {
                fontWeight: "400",
              },
            },
            "& .detail": {
              padding: `${rem(12)} 0`,
              fontSize: rem(14),
              color: "#8E8E8E",
              "& span": {
                color: theme.palette.primary.main,
              },
            },
            "&.complete": {
              "& .tit, & .detail": {
                color: theme.palette.grey[100],
              },
            },
            "&.off": {
              "& .tit, & .detail": {
                color: theme.palette.text.disabled,
              },
              "&:after": {
                backgroundImage:
                  "linear-gradient(to right, #bebebe 40%, #ffffff00 20%)",
              },
            },
            "&:after": {
              display: "block",
              content: "''",
              width: "94%",
              height: "1px",
              backgroundImage:
                "linear-gradient(to right, #eee 40%, #ffffff00 20%)",
              backgroundPosition: "left",
              backgroundSize: "7px 1px",
              backgroundRepeat: "repeat-x",
              position: "absolute",
              top: "83px",
              left: "50%",
              marginLeft: "-47%",
            },
          },
          "& .on": {
            minWidth: rem(153),
            height: rem(130),
            backgroundColor: "#fff",
            border: "1px solid #eee",
            borderRadius: rem(10),
            // backgroundImage: `url(${
            //   process.env.PUBLIC_URL
            // }/images/icon/reward-on.svg)`,
            // backgroundSize: "100% 130px",
            // backgroundRepeat: "no-repeat",
            "& .tit": {
              "&:before, &:after": {
                borderColor: "#eee",
              },
            },
          },
          "& .off": {
            minWidth: rem(153),
            height: rem(130),
            backgroundColor: "#eee",
            border: "1px solid #dfdfdf",
            borderRadius: rem(10),
            // backgroundImage: `url(${
            //   process.env.PUBLIC_URL
            // }/images/icon/reward-off.svg)`,
            // backgroundSize: "100% 130px",
            // backgroundRepeat: "no-repeat",
            "& .tit": {
              "&:before, &:after": {
                borderColor: "#dfdfdf",
              },
            },
          },
          "& .complete": {
            // position: "absolute",
            // backgroundColor: "#ffffff8a",

            "& img": {
              position: "absolute",
              mixBlendMode: "multiply",
              zIndex: "1",
            },
          },
        },
      },
      "& .guage": {
        padding: `${rem(50)} ${rem(40)} ${rem(40)} !important`,
      },
      "& .stamp-wrap": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        flexDirection: "column",
        padding: `${rem(50)} ${rem(30)}`,
        "& .MuiButton-root": {
          marginTop: rem(40),
          gap: rem(20),
        },
        "& .detail-btn": {
          fontSize: rem(14),
          marginTop: rem(22),
          textDecoration: "underline",
          textUnderlinePosition: "under",
        },
        // padding: `${rem(23)} ${rem(30)} ${rem(30)} ${rem(26)}`,
        // borderRadius: rem(10),
        // backgroundColor: palette.common.white,
        "& .MuiGrid-container": {
          margin: `${rem(-9)} 0`,
          width: "100%",
          "& .MuiGrid-item": {
            flexBasis: "20%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            padding: 0,
            margin: `${rem(9)} 0`,
            "& .stamp": {
              overflow: "hidden",
              position: "relative",
              width: rem(54),
              height: rem(54),
              borderRadius: "50%",
              // backgroundColor: theme.palette.info.light,
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/stamp-off.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              "&.on": {
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/stamp-on.svg)`,
              },
              "& img": {
                width: "100%",
              },
            },
            "& .benefit": {
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              top: "50%",
              left: "50%",
              transform: "translate(-50% , -50%)",
              backgroundColor: "#BEBEBE",
              borderRadius: rem(6),
              lineHeight: 1,
              color: "#F6F6F6",
              fontSize: rem(14),
              fontWeight: 800,
              minWidth: rem(60),
              minHeight: rem(23),
            },
            "& .date": {
              position: "absolute",
              fontSize: rem(18),
              fontWeight: 800,
              color: "#DFDFDF",
              lineHeight: rem(62),
            },
            "&.on": {
              "& .stamp": {
                overflow: "hidden",
                position: "relative",
                maxWidth: rem(54),
                maxHeight: rem(54),
                borderRadius: "50%",
                // backgroundColor: theme.palette.info.light,
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/stamp-on.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100%",
                "& img": {
                  width: "100%",
                },
              },
              "& .benefit": {
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                top: "35%",
                left: "51%",
                transform: "rotate(-15deg) translate(-50% , -50%)",
                border: `1px solid ${detailData.clr}`,
                borderRadius: rem(6),
                lineHeight: 1,
                color: `${detailData.clr}`,
                fontSize: rem(14),
                fontWeight: 800,
                backgroundColor: theme.palette.common.white,
                minWidth: rem(60),
                minHeight: rem(23),
                // margin: `${rem(9)} 0 0 ${rem(5)}`,
              },
            },
          },
        },
      },
      "& .stamp-bg-wrap": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        flexDirection: "column",
        padding: `${rem(20)}`,
        "& .MuiGrid-container": {
          margin: `${rem(-7)} 0`,
          width: "100%",
          "&.stamp-grid": {
            padding: `${rem(23)} ${rem(30)}`,
            borderRadius: rem(10),
            backgroundColor: theme.palette.common.white,
          },
          "& .MuiButton-root": {
            marginTop: rem(40),
            gap: rem(20),
          },
          "& .detail-btn": {
            fontSize: rem(14),
            margin: rem(22),
            textDecoration: "underline",
            textUnderlinePosition: "under",
          },

          "& .MuiGrid-item": {
            flexBasis: "20%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            padding: 0,
            margin: `${rem(7)} 0`,
            "& .stamp": {
              overflow: "hidden",
              position: "relative",
              width: rem(48),
              height: rem(48),
              borderRadius: "50%",
              // backgroundColor: theme.palette.info.light,
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/stamp-off.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              "&.on": {
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/stamp-on.svg)`,
              },
              "& img": {
                width: "100%",
              },
            },
            "& .benefit": {
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              top: "50%",
              left: "50%",
              transform: "translate(-50% , -50%)",
              fontWeight: 800,
              lineHeight: 1.3,
              fontSize: rem(13),
              minWidth: rem(52),
              minHeight: rem(20),
              backgroundColor: "#BEBEBE",
              borderRadius: rem(6),
              color: "#F6F6F6",
            },
            "& .date-num": {
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              color: "#DFDFDF",
              fontSize: rem(11),
              fontWeight: 800,
              lineHeight: 1,
              "& p": {
                fontSize: rem(17),
                fontWeight: 800,
                lineHeight: 1,
              },
              // lineHeight: rem(62),
            },
            "&.on": {
              "& .stamp": {
                overflow: "hidden",
                position: "relative",
                maxWidth: rem(48),
                maxHeight: rem(48),
                borderRadius: "50%",
                // backgroundColor: theme.palette.info.light,
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/stamp-on.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100%",
                "& img": {
                  width: "100%",
                },
              },
              "& .benefit": {
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                top: "35%",
                left: "52%",
                transform: "rotate(-15deg) translate(-50% , -50%)",
                border: `1px solid ${detailData.clr}`,
                borderRadius: rem(6),
                lineHeight: 1.3,
                fontSize: rem(13),
                color: `${detailData.clr}`,
                fontWeight: 800,
                backgroundColor: theme.palette.common.white,
                minWidth: rem(52),
                minHeight: rem(20),
              },
            },
          },
        },
      },
      "& .modalNodata": {
        "&.nodata": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          margin: 0,
          height: "calc(100vh - 301px)",
        },
      },
      "& .stamp-wrap .bottom-wrap .MuiButton-root": {
        gap: 0,
      },
    },
    rewardTit: {
      display: "inline",
      fontSize: rem(40),
      fontWeight: 800,
      color: theme.palette.primary.main,
      paddingBottom: rem(8),
      paddingTop: rem(15),
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },

    detailTable: {
      width: "100%",
      textAlign: "center",
      fontSize: rem(14),
      "& tr": {
        height: rem(34),
      },
      "& .bg-color": {
        backgroundColor: "#FFF9F9",
      },
    },
  }));

  const classes = useStyles();
  const [drawerReward, setDrawerReward] = useState(false);
  const [drawerDetail, setDrawerDetail] = useState(false);
  const [alert1, setAlert1] = useState(false);
  const [stampLogList, setStampLogList] = useState([]);
  const [giftIndexList, setGiftIndexList] = useState([]);
  const [alertMsg, setAlertMsg] = useState("");
  const [exdDrawer, setExdDrawer] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [rwdCnt, setRwdCnt] = useState([]);
  const [endGiftList, setEndGiftList] = useState("");
  const [paymentGiftList, setPaymentGiftList] = useState("");
  const [leftGift, setLeftGift] = useState(false);
  const history = useHistory();

  // "presentFlag": "1", // 증정구분(0: 비연속식(영수증당1회), 1: 연속식(영수증당N회))
  // "withdrawFlag": "0", // 차감구분(0: 최종 수령시 일괄 차감(미지정), 1: 개별수령시 차감)
  // "partinFlag": "1", // 참여구분(0: 자동(즉시), 1: 수동(응모버튼클릭))
  // "stampFlag": "2", // 스탬프타입(1: 달성(게이지), 2: 스탬프)

  useEffect(() => {
    createGiftIndexList();
  }, [props]);

  const checkAuth = () => {
    let token = cookies.get("X-REFRESH-TOKEN");

    let localFavInfo = cookies.get("favInfo");

    const localStoreCode = localFavInfo
      ? localFavInfo.visibleTp == "1"
        ? localFavInfo.favMt
        : localFavInfo.favMk
      : "";

    if (!token) {
      dispatch(loadAlert(true));
      return false;
    } else if (!localStoreCode) {
      dispatch(loadFavAlert(true));
      return false;
    } else return true;
  };

  const accumulate = () => {
    let localFavInfo = cookies.get("favInfo");

    const localStoreCode = localFavInfo
      ? localFavInfo.visibleTp == "1"
        ? localFavInfo.favMt
        : localFavInfo.favMk
      : "";

    axios
      .get("/api/eh/stamp/accumulate", {
        params: {
          storeCode: localStoreCode, //본인 단골매장 코드
          evtId: detailData.evtId,
        },
      })
      .then((res) => {
        if (
          res.data.data.paymentGiftList &&
          res.data.data.paymentGiftList.length > 0
        ) {
          setPaymentGiftList(res.data.data.paymentGiftList);
          setDrawerReward(true);
        } else {
          setAlertMsg("스탬프가 적립되었습니다.");
          setAlert1(true);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          setAlertMsg(error.response.data.message);
          setAlert1(true);
        }
      });
  };

  const attendance = async () => {
    let localFavInfo = cookies.get("favInfo");

    const localStoreCode = localFavInfo
      ? localFavInfo.visibleTp == "1"
        ? localFavInfo.favMt
        : localFavInfo.favMk
      : "";

    await axios
      .get("/api/eh/event/attendance", {
        params: {
          seq: event.seq,
          evtId: detailData.evtId,
          storeCode: localStoreCode, //본인 단골매장 코드
        },
      })
      .then((res) => {
        if (
          res.data.data.paymentGiftList &&
          res.data.data.paymentGiftList.length > 0
        ) {
          setPaymentGiftList(res.data.data.paymentGiftList);
          setDrawerReward(true);
        } else {
          setAlertMsg("출석 되었습니다.");
          setAlert1(true);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          setAlertMsg(error.response.data.message);
          setAlert1(true);
        }
      });
  };

  const createGiftIndexList = () => {
    let list = [];
    let j = 0;

    let lastGiftIndex = 0;

    let arr = [];
    for (let i = 0; i <= detailData.totalMaxCount; i++) {
      let item = detailData.stampGifts[j];
      if (i == item.stamp) {
        list.push({ ...item });
        lastGiftIndex = i;
        if (
          i <= detailData.accCount &&
          item.useYn == "N" &&
          item.endCfmYn == "N"
        ) {
          console.log("i", i);
          arr.push(i);
        }
        if (j < detailData.stampGifts.length - 1) j++;
      } else list.push(null);
    }
    setRwdCnt(arr);
    console.log("rwdCnt: ", rwdCnt);
    console.log("list: ", list);
    setGiftIndexList(list);
    console.log("lastGiftIndex: ", lastGiftIndex);
  };

  const loadLogDetail = async () => {
    await axios
      .get("/api/eh/stamp/stamp-log", {
        params: {
          evtId: detailData.evtId,
        },
      })
      .then((res) => {
        setStampLogList(res.data.data.stampLogList);
      });
  };

  const receiveGift = async (giftNum) => {
    console.log("@@giftNum: ", giftNum);
    let localFavInfo = cookies.get("favInfo");

    const localStoreCode = localFavInfo
      ? localFavInfo.visibleTp == "1"
        ? localFavInfo.favMt
        : localFavInfo.favMk
      : "";

    if (detailData.partinFlag == 0) {
      if (rwdCnt.length > 1) {
        setLeftGift(true);
      } else {
        setLeftGift(false);
      }
    }

    await axios
      .get("/api/eh/stamp/receive-gift", {
        params: {
          evtId: detailData.evtId,
          storeCode: localStoreCode,
          giftNum: giftNum,
        },
      })
      .then((res) => {
        console.log("리워드 받기 성공");
        setDrawerReward(true);
      })
      .catch((error) => {
        console.log("리워드 받기 실패");
        if (error.response.data.code == "SG003") {
          setExdDrawer(true);
          setErrMsg("지급 가능한 수량을 초과했습니다");
        }
        // 수량초과 drawer
        if (error.response.data.code == "SG002") {
          setExdDrawer(true);
          setErrMsg(error.response.data.message);
        }
        //이미 지급된 혜택입니다
      });
  };

  const renderReward = (item) => {
    if (!item) return;

    let render =
      item.giftFlag == "1"
        ? item.dcFlag == "1"
          ? item.couponAmount + "원"
          : item.couponAmount + "%"
        : item.giftProduct + "P";

    return render;
  };

  const getCouponType = (item) => {
    switch (item) {
      case "C":
        return "쿠폰";
      case "S":
        return "스탬프";
      case "P":
        return "포인트";
    }
  };

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (alertOpen) {
        dispatch(loadAlert(false));
      } else if (favAlertOpen) {
        dispatch(loadFavAlert(false));
      } else if (exdDrawer) {
        setExdDrawer(false);
      } else if (drawerDetail) {
        setDrawerDetail(false);
      } else if (drawerReward) {
        setDrawerReward(false);
      } else if (alert1) {
        setAlert1(false);
      } else {
        history.goBack();
      }
    };
  }, [alertOpen, favAlertOpen, exdDrawer, drawerDetail, drawerReward, alert1]);

  return (
    <div className={classes.stampDetail}>
      {!isDisabled && (
        <div
          className={
            bgYn == "Y"
              ? "stamp-bg-wrap"
              : detailData.stampFlag == "1"
              ? "stamp-wrap guage"
              : "stamp-wrap"
          }
        >
          {detailData.stampFlag == "1" ? (
            <Gauge detailData={detailData} giftIndexList={giftIndexList} />
          ) : (
            <Stamp
              atdcYn={
                (event && event.evtTp == "3") || (event && event.evtTp == "4")
                  ? "Y"
                  : "N"
              }
              detailData={detailData}
              giftIndexList={giftIndexList}
            />
          )}
          <div className="bottom-wrap">
            {rwdCnt.length &&
            detailData.partinFlag == "0" &&
            detailData.stampFlag == "2" ? (
              <>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    receiveGift(giftIndexList[rwdCnt[0]].num);
                  }}
                  className="btnLine"
                >
                  <img
                    src={`${
                      process.env.PUBLIC_URL
                    }/images/icon/icon-reward.svg`}
                  />
                  리워드 받기
                </Button>
              </>
            ) : (event && event.evtTp == "3") ||
              (event && event.evtTp == "4") ? (
              detailData.partinFlag == "1" && (
                <Button
                  fullWidth
                  variant="contained"
                  color="common"
                  onClick={() => {
                    if (checkAuth()) attendance();
                  }}
                >
                  출석체크
                </Button>
              )
            ) : (
              detailData.partinFlag == "1" && (
                <Button
                  fullWidth
                  variant="contained"
                  color="common"
                  onClick={() => {
                    if (checkAuth()) accumulate();
                  }}
                >
                  스탬프 적립
                </Button>
              )
            )}
            <Button
              className="detail-btn"
              onClick={() => {
                if (checkAuth()) {
                  setDrawerDetail(true);
                  loadLogDetail();
                }
              }}
            >
              상세내역
            </Button>
          </div>
        </div>
      )}

      {detailData.stampFlag == "1" && (
        <div className="bg-grey reward">
          <Grid
            container
            className={
              detailData.stampGifts.length == 1 ? "reward-one" : "reward-items"
            }
          >
            {detailData.stampGifts.map((item, i) => (
              <Grid
                item
                key={i}
                className={
                  item.useYn == "Y"
                    ? "complete on"
                    : detailData.etCount >= item.stamp && !isDisabled
                    ? "on"
                    : "off"
                }
                onClick={() => {
                  if (
                    detailData.etCount >= item.stamp &&
                    !isDisabled &&
                    item.useYn == "N"
                  )
                    receiveGift(item.num);
                }}
              >
                {item.useYn == "Y" && (
                  <img
                    src={`${
                      process.env.PUBLIC_URL
                    }/images/icon/reward-complete.svg`}
                  />
                )}
                <div className="tit">
                  <b>{item.giftFlag == "1" ? "할인쿠폰" : "포인트"}</b>
                  <div className="amount">{renderReward(item)}</div>
                </div>
                <div className="detail">
                  {item.useYn != "Y" &&
                  detailData.etCount >= item.stamp &&
                  !isDisabled ? (
                    <span>터치 후 리워드 받기</span>
                  ) : (
                    `목표 스탬프 ${item.stamp}개`
                  )}
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      )}

      <Drawer
        anchor="bottom"
        open={drawerReward}
        onClose={() => {
          setDrawerReward(false);
        }}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-body">
          <div className="box-type-1 align-c">
            <div className="illust" style={{ marginTop: rem(15) }}>
              <img
                src={`${process.env.PUBLIC_URL}/images/img/illust-reward.svg`}
              />
            </div>
            <div className={classes.rewardTit}>
              {renderReward(
                detailData.partinFlag == 1
                  ? giftIndexList[detailData.etCount]
                  : giftIndexList[rwdCnt[0]]
              )}{" "}
            </div>
            <Box className="text" mt={4} mb={3}>
              <strong>축하합니다! 리워드를 달성했습니다!</strong>
            </Box>
            {leftGift && (
              <Box component="span" className="count">
                남은 리워드가 있습니다.
              </Box>
            )}
          </div>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setDrawerReward(false);
              if (rwdCnt.length > 0) {
                setRwdCnt(rwdCnt.splice(0, 1));
              }
              props.fetchData();
            }}
          >
            확인
          </Button>
        </div>
      </Drawer>

      <Drawer
        anchor="bottom"
        open={drawerDetail}
        onClose={() => {
          setDrawerDetail(false);
        }}
        className="drawer-common-bottom size-high"
      >
        <div className="drawer-head">
          <h3>상세내역</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={() => {
              setDrawerDetail(false);
            }}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-11">
            <table className={classes.detailTable}>
              <colgroup>
                <col style={{ width: "27%" }} />
                <col style={{ width: "27%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "27%" }} />
                {/* <col style={{ width: "33%" }} />
                <col style={{ width: "33%" }} />
                <col style={{ width: "33%" }} /> */}
              </colgroup>
              <tbody>
                <tr>
                  <th>적립 내용</th>
                  <th>적립 일자</th>
                  <th>상태</th>
                  <th>점포명</th>
                </tr>
                {stampLogList.map((item, i) => (
                  <tr
                    key={i}
                    className={item.couponType == "S" ? "" : "bg-color"}
                  >
                    <td>{`${getCouponType(item.couponType)} (${
                      item.accCount
                    })`}</td>
                    <td>{moment(item.stampDate).format("YYYY.MM.DD")}</td>
                    <td>{item.cancFlag == "1" ? "취소" : "적립"}</td>
                    <td>{item.storeName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {stampLogList.length === 0 && (
              <div
                className="modalNodata nodata"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  margin: 0,
                  height: "calc(100vh - 301px)",
                }}
              >
                <Box className="illust">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                  />
                </Box>
                <p className="color-info">적립 내역이 없습니다</p>
              </div>
            )}
          </Box>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setDrawerDetail(false);
            }}
          >
            확인
          </Button>
        </div>
      </Drawer>

      {/* ST : Alert */}
      <Dialog
        open={alert1}
        onClose={() => {
          setAlert1(false);
        }}
        className="alert-wrap"
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle className="tit-center" id="alert-dialog-title">
          알림
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{alertMsg}</DialogContentText>
        </DialogContent>
        <DialogActions className="btn-center">
          <Button
            onClick={() => {
              setAlert1(false);
              props.fetchData();
            }}
            autoFocus
            variant="contained"
            color="primary"
            size="small"
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
      {/* EN : Alert */}

      <Drawer
        anchor="bottom"
        open={exdDrawer}
        onClose={() => {
          setExdDrawer(false);
        }}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-body">
          <div className="box-type-1 align-c">
            <div className="illust" style={{ marginTop: rem(15) }}>
              <img src={`${process.env.PUBLIC_URL}/images/icon/warning.svg`} />
            </div>

            <Box className="text" mt={4} mb={2}>
              <strong>{errMsg}</strong>
            </Box>
            {/* //자동이면서 리워드 남은부분 있을 때 */}
            {/* {detailData.partinFlag == "0" && <p className="color-info-sm">남은 리워드가 있습니다.</p>} */}
          </div>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setExdDrawer(false);
              props.fetchData();
            }}
          >
            확인
          </Button>
        </div>
      </Drawer>
    </div>
  );
}
